import React from 'react';
import {Td} from "@chakra-ui/react";
import {IProject} from "../../models/interfaces/project.interface.ts";
import {useProject} from "../../hooks/useProject.ts";
import ProjectStateBadge from "../ProjectStateBadge.tsx";

interface ProjectTableStateColumnProps {
  project: IProject;
}

const ProjectTableStateColumn: React.FC<ProjectTableStateColumnProps> = ({project}) => {
  const {getProjectStateEnum} = useProject();
  return (
    <Td
      textAlign="left"
    >
      <ProjectStateBadge state={getProjectStateEnum(project)}/>
    </Td>

  );
}

export default ProjectTableStateColumn;